export default "__VITE_ASSET__0eee6557__"